import { createContext } from 'react';

// Boolean — true when in preview/read-only mode
export const PreviewCtx = createContext(false);

// Stub context — used by Section/elements to read breakpoint and drag refs
// In read-only mode, drag refs are never written to
export const DragCtx = createContext(null);

// No-op context menu — keeps imports compatible if anything still references it
export const CtxMenuCtx = createContext({ open: () => {} });
